import { ExpandLess, ExpandMore } from '@mui/icons-material';
import BarChartIcon from '@mui/icons-material/BarChart';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface IIndicators {
  isAdmin: boolean;
  isManufacturerAdmin: boolean;
  isTransporterAdmin: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const Indicators = ({ isAdmin, isManufacturerAdmin, isTransporterAdmin, onExpand, isExpanded, index, drawerIsOpen, setOpen }: IIndicators) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.indicators">Indicators</Translate>} placement="right">
        <ListItemButton
          id="indicators-button"
          onClick={() => onExpand(index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.indicators">Indicators</Translate>}
            primaryTypographyProps={{
              fontFamily: 'Public Sans',
              fontWeight: isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        {(isAdmin || isManufacturerAdmin || isTransporterAdmin) && (
          <List component="div" disablePadding onClick={() => setOpen(false)}>
            <MenuItem icon="caret-right" to="/indicators/indicator-fuel-consumption">
              <Translate contentKey="fleetSenseApp.indicator.indicatorTypes.fuelConsumption" />
            </MenuItem>
          </List>
        )}
      </Collapse>
    </>
  );
};
